import { FC, useEffect, useState } from 'react'
import Link from 'next/link'
import Image from 'next/image'
import { useRouter } from 'next/router'

import CourseCard from 'components/cards/course-card/course-card'

import { getAxiosCounted } from 'pages/api/axios'
import { CoursesSearchURL } from 'constants/search-data/courses-search-data'
import { ICourseType } from 'constants/types/course.types'
import { Pathname, STATIC_URL } from 'constants/data'

import stylesCommon from '../nmo-instruction.module.scss'
import styles from './nmo-program-cards.module.scss'

const imgData = {
  go: {
    src: `${STATIC_URL}/intro-alt/necessary/icon_go.svg`,
    alt: 'Все курсы',
    width: 18,
    height: 14,
  },
}

interface INMOProgramCard {
  title?: string
  firstCourse?: number
  secondCourse?: number
}

const NMOProgramCards: FC<INMOProgramCard> = ({
  title = 'Программы обучения Medpoint c баллами НМО',
  firstCourse = 5,
  secondCourse = 4,
}) => {
  const router = useRouter()

  const [cardsData, setCardsData] = useState([] as ICourseType[])

  const goToPrograms = () => {
    router.push(`/${Pathname.NMO_COURSE}`)
  }

  useEffect(() => {
    const getData = async () => {
      let data = await getAxiosCounted(`${CoursesSearchURL.COURSES_SINGLE}?limit=5`)
      data = (data?.rows || []).filter(
        (course: any) => course.id === firstCourse || course.id === secondCourse
      )
      setCardsData(data)
    }

    getData()
  }, [])

  return (
    <div>
      <h2 className={stylesCommon.title}>{title}</h2>
      <div className={styles.cardsWrap}>
        {cardsData.map((cardData) => {
          const { linkTranslation, name, id } = cardData

          const cardUrl = `/${Pathname.NMO_COURSE}/${linkTranslation || id}`
          return (
            <Link href={cardUrl} key={name} prefetch={false}>
              <CourseCard {...cardData} available={false} isPc={false} isWithoutPrice />
            </Link>
          )
        })}
      </div>
      <button onClick={goToPrograms} className={styles.buttonMore}>
        <p>Все курсы НМО </p>
        <Image {...imgData.go} className={styles.btnArrow} />
      </button>
    </div>
  )
}

export default NMOProgramCards
